<template>
    <div class="partners">
        <div class="core">
            <div class="link-top"></div>
            <div class="tit">{{ $t("home.partners") }}</div>
            <div class="link-top"></div>
        </div>

        <div class="center">
            <!--         <div class="partner partner1"><img src="http://pili-vod.uenc.net/1507c7f63b4a46ff97f98d8c2ebd329e.png"></div>-->
            <!--      <div class="partner">111</div>-->
            <!--      <div class="partner">111</div>-->
            <!--      <div class="partner partner4">111</div>-->
            <div class="partner" v-for="member in Members">
                <div class="images">
                    <img :src="member.images" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {
        GetPartnerList,
    } from '@/assets/server/api.js';

    export default {

        data() {
            return {
                Members: [],
                dialogVisible: false,
                email: '',
                pageSize: 1,
                total: 0,
            };
        },
        created() { this.getPartnersList(); },
        mounted() {},
        destroyed() {},
        methods: {
            async getPartnersList() {
                const data = await GetPartnerList();
                console.log(data);
                if (data.code === 0) {
                    this.total = data.total;
                    this.Members = data.rows;
                } else {
                    this.$message.error(data.msg);
                }
            },
        },
    };
</script>
<style lang="less">
    .w1352 {
        width: 1200px;
        margin: 0 auto;
    }
    .w1300 {
        width: 67%;
        margin: 0 auto;
    }
    @keyframes showBottom {
        to {
            opacity: 1;
            transform: translateY(0px);
        }
    }
    @keyframes hideBottom {
        to {
            opacity: 0;
            transform: translateY(100px);
        }
    }
</style>
<style lang="less" scoped>
    @keyframes showLeft {
        to {
            opacity: 1;
            transform: translateX(0px);
        }
    }
    @keyframes showRight {
        to {
            opacity: 1;
            transform: translateX(0px);
        }
    }
    @keyframes hideLeft {
        to {
            opacity: 0;
            transform: translateX(-100px);
        }
    }
    @keyframes hideRight {
        to {
            opacity: 0;
            transform: translateX(100px);
        }
    }
    @keyframes scaleUp-animation {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.25);
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes scaleDown-animation {
        0% {
            transform: scale(1.25);
        }
        50% {
            transform: scale(1);
        }
        100% {
            transform: scale(1.25);
        }
    }
    .scale {
    }
    .scale :hover {
        transform: rotate(7deg);
        -ms-transform: rotate(7deg); /* IE 9 */
        -moz-transform: rotate(7deg); /* Firefox */
        -webkit-transform: rotate(7deg); /* Safari 和 Chrome */
        -o-transform: rotate(7deg); /* Opera */
        color: red;
    }

    .partners {
        text-align: center;
        margin-top: 200px;
        height: 850px;
        margin-bottom: 91px;
        .core {
            display: flex;
            width: 750px;
            margin: 0 auto;
            text-align: center;
            .link-top {
                height: 1px;
                background: #E8EAF2;
                border-radius: 0px 0px 0px 0px;
                opacity: 1;

                justify-content: center;
                width: 40%;
                margin-top: 14.5px;
                vertical-align: middle;
            }
            .tit {
                font-size: 20px;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
                color: #61678C;
                line-height: 20px;
            }
        }
        .center {
            text-align: center;
            margin-top: 80px;

            .partner {
                width: 313px;
                height: 100px;
                border-radius: 0px 0px 0px 0px;
                opacity: 1;
                float: left;
                margin-left:40px;
                margin-bottom: 40px;
                /*background: linear-gradient(*/
                /*  180deg,*/
                /*  #8277ff 0%,*/
                /*  rgba(130, 119, 255, 0) 100%*/
                /*);*/
                img{
                    width: 313px;
                    height: 100px;
                }
            }
        }
    }
</style>
